import { useTranslation } from '@/i18n';
import { LandingNav } from './components/LandingNav';
import { LandingFooter } from './components/LandingFooter';

const CONTACT_EMAIL = 'ziangxuu@gmail.com';

export default function ContactPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <LandingNav />
      <main className="flex-1 pt-24 pb-16 md:pt-32 md:pb-24">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900">
            {t('landing.contact.title')}
          </h1>
          <p className="mt-4 text-lg text-gray-600">
            {t('landing.contact.subtitle')}
          </p>

          <div className="mt-10 bg-gray-50 rounded-xl p-6 md:p-8 border border-gray-100">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-sky-50 to-indigo-50 flex items-center justify-center text-sky-600 flex-shrink-0">
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <div>
                <h2 className="text-sm font-semibold text-gray-900 mb-1">
                  {t('landing.contact.emailLabel')}
                </h2>
                <a
                  href={`mailto:${CONTACT_EMAIL}`}
                  className="text-sky-600 hover:text-sky-700 font-medium transition-colors"
                >
                  {CONTACT_EMAIL}
                </a>
              </div>
            </div>
          </div>
        </div>
      </main>
      <LandingFooter />
    </div>
  );
}
